import { FeatureDc, PolygonDc, PolylineDc } from "@evergis/api";
import { isPolygonFeature, isPolylineFeature } from "../../../interfaces/features";

/**
 * grouped feature it is feature which has 2 and more geometry objects
 */
export const isGroupedFeature = (feature: FeatureDc): boolean => {
  if (isPolylineFeature(feature)) {
    return (feature.geometry as PolylineDc).coordinates.length > 1;
  }

  if (isPolygonFeature(feature)) {
    return (feature.geometry as PolygonDc).coordinates.length > 1;
  }

  return false;
};
